



































































import { Vue, Component, Prop } from 'vue-property-decorator';
import Typography from '@/components/atoms/Typography/Typography.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';

import BonusLargeIcon from '@/components/icons/BonusLargeIcon.vue';
import BonusSmallIcon from '@/components/icons/BonusSmallIcon.vue';
import CoinRotateBottomLargeIcon from '@/components/icons/CoinRotateBottomLargeIcon.vue';
import CoinRotateBottomSmallIcon from '@/components/icons/CoinRotateBottomSmallIcon.vue';
import CoinRotateCenterIcon from '@/components/icons/CoinRotateCenterIcon.vue';
import CoinRotateTopIcon from '@/components/icons/CoinRotateTopIcon.vue';

@Component({
  components: {
    Typography,
    FilledButton,
    BonusLargeIcon,
    BonusSmallIcon,
    CoinRotateBottomLargeIcon,
    CoinRotateBottomSmallIcon,
    CoinRotateCenterIcon,
    CoinRotateTopIcon
  }
})
export default class BoostSalesOfCoinsBanner extends Vue {
  @Prop() description!: string;
  @Prop() canManageSellCoins!: boolean;

  get tPrefix() {
    return 'sellCoins.boostSalesOfCoinsBanner';
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'];
  }

  get hasSellCoinsEnabled() {
    return this.canManageSellCoins && this.businessInfo.sellCoins;
  }

  gotoSellCoinsCampaign() {
    this.$router.push('/sell-coins/campaign/create');
  }
}
